import styled from 'styled-components'
import { breakpoints } from '../../../breakpoints'

export const FieldLabel = styled.div`
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #585b78;
  opacity: 0.75;

  @media (max-width: ${breakpoints.sm}px) {
    font-size: 10px;
    line-height: 10px;
  }
`
